import {Skeleton as MantineSkeleton} from '@mantine/core';

/**
 * Loading placeholder block — design-layer pass-through over Mantine `Skeleton`.
 * @registry Pass-through Mantine Skeleton; import this instead of @mantine/core outside src/design.
 */
export const Skeleton = MantineSkeleton;
